/**
Copyright [2022] [https://www.merac.com
 */
/*
 * @Descripttion: 工具集
 * @version: 1.1
 * @LastEditors: yubaoshan
 * @LastEditTime: 2022年4月19日10:58:41
 */
const tool = {}

// localStorage
tool.data = {
	set(table, settings) {
		const _set = JSON.stringify(settings)
		const result = localStorage.setItem(table, _set)
		if (typeof window !== 'undefined') {
			window.dispatchEvent(new CustomEvent('digit:data:set', { detail: { key: table } }))
		}
		return result
	},
	get(table) {
		let data = localStorage.getItem(table)
		try {
			data = JSON.parse(data)
		} catch (err) {
			return null
		}
		return data
	},
	remove(table) {
		return localStorage.removeItem(table)
	},

	clear() {
		return localStorage.clear()
	}
}

// sessionStorage
tool.session = {
	set(table, settings) {
		const _set = JSON.stringify(settings)
		return sessionStorage.setItem(table, _set)
	},
	get(table) {
		let data = sessionStorage.getItem(table)
		try {
			data = JSON.parse(data)
		} catch (err) {
			return null
		}
		return data
	},
	remove(table) {
		return sessionStorage.removeItem(table)
	},
	clear() {
		return sessionStorage.clear()
	}
}

// 千分符
tool.groupSeparator = (num) => {
	num = `${num}`
	if (!num.includes('.')) num += '.'

	return num
		.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
			return `${$1},`
		})
		.replace(/\.$/, '')
}

// 获取所有字典数组
tool.dictDataAll = () => {
	return tool.data.get('DICT_TYPE_TREE_DATA')
}

// 字典翻译方法，界面插槽使用方法 {{ $TOOL.dictType('sex', record.sex) }}
tool.dictTypeData = (dictValue, value) => {
	const dictTypeTree = tool.dictDataAll()
	if (!Array.isArray(dictTypeTree)) {
		return ''
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (!tree) {
		return ''
	}

	// 特殊处理：当值为空时的显示逻辑
	if (value === null || value === undefined || value === '') {
		// 对于性别字段，显示"待设置"
		if (dictValue === 'MEMBER_SEX') {
			return '待设置'
		}
		// 对于其他字段，可以根据需要添加特殊处理
		return ''
	}

	const children = tree.children
	const dict = children.find((item) => item.dictValue === value + "")
	return dict ? dict.dictLabel : ''
	// return dict ? dict.dictLabel : '无此字典项'
}

// 获取某个code下字典的列表，多用于字典下拉框
tool.dictTypeList = (dictValue) => {
	const dictTypeTree = tool.dictDataAll()
	if (!Array.isArray(dictTypeTree)) {
		return []
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (tree && tree.children) {
		return tree.children
	}
	return []
}

// 获取某个code下字典的列表，基于dictTypeList 改进，保留老的，逐步替换
tool.dictList = (dictValue) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		console.warn(`没有找到字典数据，dictValue: ${dictValue}`)
		return []
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (tree && tree.children && Array.isArray(tree.children)) {
		return tree.children.map((item) => {
			const label = item.dictLabel || item.name || item.dictValue
			return {
				code: item.dictValue,
				label,
				value: label
			}
		})
	}
	console.warn(`没有找到字典数据 ${dictValue} 或其没有children属性`)
	return []
}

// 生成UUID
tool.snowyUuid = () => {
	let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		let r = (Math.random() * 16) | 0,
			v = c === 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})
	// 首字符转换成字母
	return 'xn' + uuid.slice(2)
}

// 安全的JSON序列化函数，用于处理循环引用问题
tool.safeStringify = (obj) => {
	if (obj === undefined || obj === null) {
		return JSON.stringify(obj);
	}

	const seen = new WeakSet();
	return JSON.stringify(obj, (key, value) => {
		// 跳过可能导致循环引用的特殊属性
		if (key === 'component' || key === 'vnode' || key === 'parent' || key === '$el' || key === '__v_isRef') {
			return '[Circular]';
		}
		if (typeof value === 'object' && value !== null) {
			if (seen.has(value)) {
				return '[Circular]';
			}
			seen.add(value);
		}
		return value;
	});
};

export default tool
